var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2803 3.96967C16.5732 4.26256 16.5732 4.73744 16.2803 5.03033L7.28033 14.0303C6.98744 14.3232 6.51256 14.3232 6.21967 14.0303L1.71967 9.53033C1.42678 9.23744 1.42678 8.76256 1.71967 8.46967C2.01256 8.17678 2.48744 8.17678 2.78033 8.46967L6.75 12.4393L15.2197 3.96967C15.5126 3.67678 15.9874 3.67678 16.2803 3.96967Z",
    fill: "#C7CDD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.e96277580cdf80654a358ec83ff9371b.svg";
export { ForwardRef as ReactComponent };